import React, { useEffect, useState } from "react";
import AddNewMember from "./AddNewMember";
import { useParams, Link } from 'react-router-dom';
import configVars from "../../config";
import { getWithExpiry, setWithExpiry } from '../../common';
import { useTranslation } from "react-i18next";
import OrganizationMembers from "./OrganizationMembers";
import OrganizationSummary from "./OrganizationSummary";
import AddNewTeam from "./AddNewTeam";
import TeamsSummary from "./TeamsSummary";
import ChangeOwner from "./ChangeOwner";

const SingleOrganization = () => {

    const { organization_id, method, team_id, sub_teams, sub_team_id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [organizationName, setOrganizationName] = useState('');
    const [organizationUsers, setOrganizationUsers] = useState([]);
    const [organizationTeams, setOrganizationTeams] = useState([]);
    const [orgOwner, setOrgOwner] = useState({});
    const [orgManagers, setOrgManagers] = useState([]);
    const [totalMembers, setTotalMembers] = useState(0);
    
    const [translation] = useTranslation("translations");

    useEffect(() => {

        const organizationData = getWithExpiry( `sy_org_${organization_id}_data` );

        if ( organizationData ) {
            setOrganizationName( organizationData.organization_name );
            setOrganizationUsers( organizationData.users );

            if ( organizationData.owner ) {
                setOrgOwner(organizationData.owner);
            }

            if ( organizationData.managers ) {
                setOrgManagers( organizationData.managers );
            }

            if ( organizationData.teams ) {
                setOrganizationTeams( organizationData.teams );
            }
            if (  organizationData.user_count ) {
                setTotalMembers(  organizationData.user_count );
            }
        } else {

            (async () => {

                setIsLoading( true );
    
                const response = await fetch(
                    `${configVars.apiUrl}sustainchange/v1/getorganization/?organizationid=${organization_id}`,
                    {
                      method: "GET",
                      headers: {
                        Authorization: `Basic ${configVars.auth}`,
                      },
                    }
                );
                
                const companyResponse = await response.json();
                
                if ( companyResponse ) {
    
                    if ( companyResponse.success === true ) {
    
                        setOrganizationName( companyResponse.data.organization_name );
                        setOrganizationUsers( companyResponse.data.users );

                        if ( companyResponse?.data?.owner ) {
                            setOrgOwner(companyResponse?.data?.owner);
                        }

                        if ( companyResponse?.data?.managers ) {
                            setOrgManagers( companyResponse?.data?.managers );
                        }

                        if ( companyResponse.data.teams ) {
                            setOrganizationTeams( companyResponse.data.teams );
                        }

                        if ( companyResponse.data.user_count ) {
                            setTotalMembers( companyResponse.data.user_count );
                        }

                        setWithExpiry( `sy_org_${organization_id}_data`, companyResponse.data );
    
                    }
    
                    setIsLoading( false );
                }
    
            })()

        }

    }, [organization_id]);

    const mainTabs = ['hvi', 'ovi', 'admin'];

    return (
        <div className="px-4 organization-inner" style={{ maxWidth: "1400px" }}>

            {isLoading &&
                <div className="d-flex">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            }

            { ( method && ! mainTabs.includes(method) ) && (!team_id && !sub_teams) &&
                <Link to={`/organizations/${organization_id}/admin/`} className="btn btn-link px-0" >
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                    <span className="ps-2">Gå tillbaka</span>
                </Link>
            }

            { ( method && ! mainTabs.includes(method) ) && (team_id && !sub_teams) &&
                <Link to={`/organizations/${organization_id}/teams/`} className="btn btn-link px-0" >
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                    <span className="ps-2">Gå tillbaka</span>
                </Link>
            }

            { ( method && ! mainTabs.includes(method) ) && (team_id && sub_teams && (sub_teams !== 'edit' && sub_teams !== 'members')) &&
                <Link to={`/organizations/${organization_id}/teams/${team_id}/`} className="btn btn-link px-0" >
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                    <span className="ps-2">Gå tillbaka</span>
                </Link>
            }

            {(sub_teams === 'edit' || sub_teams === 'members') && !sub_team_id &&
                <Link to={`/organizations/${organization_id}/teams/${team_id}/`} className="btn btn-link px-0" >
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                    <span className="ps-2">Gå tillbaka</span>
                </Link>
            }

            { ( method && ! mainTabs.includes(method) ) && (team_id && sub_teams && (sub_teams === 'edit' || sub_teams === 'members') && sub_team_id ) &&
                <Link to={`/organizations/${organization_id}/teams/${team_id}/sub-teams/${sub_team_id}`} className="btn btn-link px-0" >
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                    <span className="ps-2">Gå tillbaka</span>
                </Link>
            }

            <h2 className="mt-4">{organizationName}
                {method === 'members' && organizationUsers && totalMembers > 0 &&
                    <span className="badge bg-primary ms-2 rounded-pill px-4 py-3">{totalMembers} {translation("members")}</span>
                }

                {/* { method === 'members' &&
                    <Link to={`/organizations/${organization_id}/new-member`} className="btn btn-primary float-lg-end mt-4 mt-lg-0 text-white" >
                        <span className="pe-2">{translation("add_new_member")}</span>
                        <i className="fa fa-plus" aria-hidden="true"></i>
                    </Link>
                } */}

                { method && method === 'new-member' &&
                    <Link to={`/organizations/${organization_id}/members`} className="btn btn-primary float-end text-white" >
                        <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                        <span className="ps-2">{translation("back_to_members")}</span>
                    </Link>
                }
            </h2>

            {(!method || mainTabs.includes( method )) &&
                <OrganizationSummary
                    members={organizationUsers}
                    teams={organizationTeams}
                    owner={orgOwner}
                    managers={orgManagers}
                    membersCount={totalMembers}
                />
            }

            { method && method === 'members' &&
                <OrganizationMembers members={organizationUsers} membersCount={totalMembers} />
            }

            { method && method === 'managers' &&
                <OrganizationMembers members={orgManagers} type="managers"  />
            }

            { method && method === 'new-member' &&
                <AddNewMember organization={organization_id} userData={ data => setOrganizationUsers(data) } />
            }

            { method && method === 'new-team' &&
                <AddNewTeam members={organizationUsers} />
            }

            { method && method === 'teams' &&
                <TeamsSummary teams={organizationTeams} members={organizationUsers} owner={orgOwner} />
            }

            { method && method === 'owner' &&
                <ChangeOwner owner={orgOwner} />
            }

        </div>
    );
};

export default SingleOrganization;
